import {
    GetAssessmentModelList,
    DeleteAssessmentModel,
    ChangeAssessmentModelStatus,
    PostAssessmentModel,
    GetAssessmentModel,
    UpdateAssessmentModel,
    PostAssessmentQuestion,
    GetAssessmentQuestion,
    UpdateAssessmentQuestion,
    DeleteAssessmentQuestion,
} from '@src/services/assessment-model'
export const state = {
    assessmentModelList: [],
    profilesList: [],
}

export const getters = {
    totalList(state) {
        return state.assessmentModelList.data
            ? state.assessmentModelList.data.totalItemCount
            : 0
    },
}

export const mutations = {
    SET_LIST(state, newList) {
        state.assessmentModelList = newList
    },
    NEXT_PAGE_LIST(state, list) {
        list.forEach((assessmentModel) => {
            state.assessmentModelList.data.items.push(assessmentModel)
        })
    },
    SET_STATUS(state, assessmentModel) {
        state.assessmentModelList.data.items.find(({ publicId }) => {
            return publicId === assessmentModel.publicId
        }).status = assessmentModel.status
    },
}

export const actions = {
    async fetchList({ commit }, parameters = {}) {
        const resp = await GetAssessmentModelList(parameters)
        if (resp.status === 200) {
            commit('SET_LIST', resp.data)
        }
    },
    async nextPage({ commit }, currentPage) {
        const resp = await GetAssessmentModelList(currentPage)
        if (resp.status === 200) {
            commit('NEXT_PAGE_LIST', resp.data.data.items)
        }
    },
    async deleteAssessmentModel({ dispatch }, assessmentModel) {
        const resp = await DeleteAssessmentModel(assessmentModel)
        if (resp.status === 200) {
            dispatch('fetchList')
        }
        return resp
    },
    async changeAssessmentStatus({ commit, dispatch }, parameters) {
        const resp = await ChangeAssessmentModelStatus(parameters)
        if (resp.status === 200) {
            commit('SET_STATUS', parameters)
            dispatch('fetchList')
        }
        return resp
    },
    async toggleCurrentForm({ _ }, assessmentModel) {
        const resp = await ChangeAssessmentModelStatus(assessmentModel)
        return resp
    },
    async createAssessmentModel({ _ }, assessmentModel) {
        const resp = await PostAssessmentModel(assessmentModel)
        return resp
    },
    async setAssessmentModelForm({ _ }, assessmentModel) {
        const resp = await GetAssessmentModel(assessmentModel)
        return resp
    },
    async updateAssessmentModel({ _ }, assessmentModel) {
        const resp = await UpdateAssessmentModel(assessmentModel)
        return resp
    },
    async createAssessmentQuestion({ _ }, assessmentQuestion) {
        const resp = await PostAssessmentQuestion(assessmentQuestion)
        return resp
    },
    async updateAssessmentQuestion({ _ }, assessmentQuestion) {
        const resp = await UpdateAssessmentQuestion(assessmentQuestion)
        return resp
    },
    async setAssessmentQuestionForm({ _ }, assessmentQuestion) {
        const resp = await GetAssessmentQuestion(assessmentQuestion)
        return resp
    },
    async deleteAssessmentQuestion({ _ }, assessmentQuestions) {
        const resp = await DeleteAssessmentQuestion(assessmentQuestions)
        return resp
    },
}
